<script>
  import { gameInfos } from '@/data/games';
  import { GameLauncher } from '@/mixins/game-launcher';
  import CtaButton from '@/components/base/CtaButton.vue';

  export default {
    name: 'GamesList',

    props: {
      redirectToPVPBuyInPage: {
        type: Boolean,
        default: false,
      },

      type: {
        type: String,
        default: '',
      },
    },

    mixins: [GameLauncher],

    components: {
      CtaButton,
      PalmIcon: async () => await import('@/assets/images/svg/icons/palm.svg'),
      AchievementIcon: async () => await import('@/assets/images/svg/icons/achievement.svg'),
      DefeatIcon: async () => await import('@/assets/images/svg/icons/defeat.svg'),
      AimIcon: async () => await import('@/assets/images/svg/icons/aim.svg'),
      StrikeIcon: async () => await import('@/assets/images/svg/icons/strike.svg'),
      FragmentsIcon: async () => await import('@/assets/images/svg/icons/fragments.svg'),
      UseIcon: async () => await import('@/assets/images/svg/icons/use.svg'),
      ReceiveIcon: async () => await import('@/assets/images/svg/icons/receive.svg'),
      TakeDownIcon: async () => await import('@/assets/images/svg/icons/take-down.svg'),
      CriticalIcon: async () => await import('@/assets/images/svg/icons/critical.svg'),
      CubeIcon: async () => await import('@/assets/images/svg/icons/cube.svg'),
      SpecialWeaponIcon: async () => await import('@/assets/images/svg/icons/special-weapon.svg'),
    },

    data: () => ({
      clickedCard: null,
      selectedGame: null,
      games: [
        {
          imageURL: '/images/cards/games/SX.png',
          alias: 'SECTOR_X',
          title: 'Sector X',
          id: 867,
          comingSoon: false,
          disabled: false,
          gameIdFF: '866',
          route: 'sector-x',
          bullets: gameInfos['sector-x']?.pvp || [],
        },
        {
          imageURL: '/images/cards/games/DS.png',
          title: 'DragonStone',
          alias: 'DRAGON_STONE',
          id: 856,
          comingSoon: false,
          disabled: false,
          gameIdFF: '838',
          route: 'dragonstone',
          bullets: gameInfos['dragonstone']?.pvp || [],
        },
        {
          imageURL: '/images/cards/games/MA.png',
          title: 'Mission Amazon',
          id: 862,
          comingSoon: false,
          disabled: false,
          gameIdFF: '859',
          route: 'mission-amazon',
          bullets: gameInfos['mission-amazon']?.pvp || [],
        },
        {
          imageURL: '/images/cards/games/RA.png',
          title: 'Return of RA',
          id: 829,
          comingSoon: true,
          disabled: false,
          bullets: gameInfos['return-of-ra']?.pvp || [],
        },
      ],
      newGamesList: [
        // {
        //   imageURL: '/images/cards/new/Escape-The-Circle.webp?v=1',
        //   title: 'Escape The Circle',
        //   alias: 'ESCAPE_THE_CIRCLE',
        //   comingSoon: true,
        //   disabled: true,
        //   id: 10,
        //   redirect: 'playervsplayer/escape-the-circle',
        //   bullets: gameInfos['escape-the-circle']?.pvp || [],
        // },
        {
          imageURL: '/images/cards/new/MM.webp?v=1',
          title: 'MultiMines',
          alias: 'MULTIMINES',
          comingSoon: true,
          disabled: true,
          id: 6,
          redirect: 'playervsplayer/multimines',
          bullets: gameInfos['multi-mines']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/R21.webp?v=1',
          title: 'Rolling 21',
          alias: 'ROLLING_21',
          comingSoon: true,
          disabled: true,
          id: 5,
          redirect: 'playervsplayer/rolling-21',
          bullets: gameInfos['rolling-21']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/ROH.webp?v=1',
          title: 'Roll Or Hold',
          alias: 'ROLL_OR_HOLD',
          comingSoon: true,
          disabled: true,
          id: 2,
          redirect: 'playervsplayer/roll-or-hold',
          bullets: gameInfos['roll-or-hold']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/MP.webp?v=1',
          title: 'Multiplinko',
          alias: 'MULTIPLINKO',
          redirect: '/lobby/plinko',
          id: 1,
          comingSoon: false,
          disabled: false,
          bullets: gameInfos['plinko']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/MBC.webp?v=1',
          title: 'MaxBlast Champs',
          alias: 'MAX_BLAST_CHAMPS',
          id: 864,
          comingSoon: false,
          disabled: false,
          redirect: '/maxblastchamps',
          bullets: gameInfos['maxblast']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/SX.webp?v=1',
          alias: 'SECTOR_X',
          title: 'Sector X',
          id: 867,
          comingSoon: false,
          disabled: false,
          gameIdFF: '866',
          route: 'sector-x',
          bullets: gameInfos['sector-x']?.pvp || [],
        },
        {
          imageURL: '/images/cards/fastplay/Dragonstone.png',
          title: 'DragonStone',
          alias: 'DRAGON_STONE',
          id: 856,
          comingSoon: false,
          disabled: false,
          gameIdFF: '838',
          route: 'dragonstone',
          bullets: gameInfos['dragonstone']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/MA.webp?v=1',
          title: 'Mission Amazon',
          alias: 'MISSION_AMAZON',
          id: 862,
          comingSoon: false,
          disabled: false,
          gameIdFF: '859',
          route: 'mission-amazon',
          bullets: gameInfos['mission-amazon']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/RA.webp?v=1',
          title: 'Return of RA',
          alias: 'RETURN_OF_RA',
          comingSoon: true,
          disabled: false,
          id: 829,
          bullets: gameInfos['return-of-ra']?.pvp || [],
        },
      ],
      fpGames: [
        {
          imageURL: '/images/cards/fastplay/Max21.png',
          title: 'Max 21',
          comingSoon: false,
          disabled: true,
          id: 9,
          launchConfig: [9, 'FF', 'extended', 9],
          bullets: gameInfos['max-21']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/MaxDice.png',
          title: 'Max Dice',
          comingSoon: false,
          disabled: true,
          id: 7,
          launchConfig: [7, 'FF', 'extended', 7],
          bullets: gameInfos['max-dice']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/FastMines.webp',
          title: 'FastMines',
          comingSoon: false,
          disabled: true,
          id: 8,
          launchConfig: [8, 'FF', 'extended', 8],
          bullets: gameInfos['fastmines']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/Olympus.png',
          title: 'Olympus Plinko',
          comingSoon: false,
          disabled: false,
          id: 11,
          launchConfig: [11, 'PL', 'extended', 11],
          bullets: gameInfos['plinko']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/TripleMB.png',
          title: 'Triple Max Blast',
          gameIdFF: '875',
          comingSoon: false,
          disabled: false,
          id: 875,
          redirect: 'maxblast',
          bullets: gameInfos['maxblast']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/SectorX.png',
          alias: 'SECTOR_X',
          title: 'Sector X',
          comingSoon: false,
          disabled: false,
          id: 867,
          gameIdFF: '866',
          route: 'sector-x',
          bullets: gameInfos['sector-x']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/Dragonstone.png',
          title: 'DragonStone',
          alias: 'DRAGON_STONE',
          comingSoon: false,
          disabled: false,
          id: 856,
          gameIdFF: '838',
          route: 'dragonstone',
          bullets: gameInfos['dragonstone']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/MissionA.png',
          title: 'Mission Amazon',
          id: 862,
          comingSoon: false,
          disabled: false,
          gameIdFF: '859',
          route: 'mission-amazon',
          bullets: gameInfos['mission-amazon']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/ReturnRA.png',
          title: 'Return of RA',
          id: 829,
          comingSoon: true,
          disabled: false,
          gameIdFF: 829,
          bullets: gameInfos['return-of-ra']?.fastplay || [],
        },
      ],
      fpMobileGames: [
        {
          imageURL: '/images/cards/fastplay/TripleMB.png',
          title: 'Triple Max Blast',
          gameIdFF: '875',
          comingSoon: false,
          disabled: false,
          id: 864,
          redirect: 'maxblast',
          bullets: gameInfos['maxblast']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/SectorX.png',
          alias: 'SECTOR_X',
          title: 'Sector X',
          comingSoon: false,
          disabled: false,
          id: 867,
          gameIdFF: '866',
          route: 'sector-x',
          bullets: gameInfos['sector-x']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/Dragonstone.png',
          title: 'DragonStone',
          alias: 'DRAGON_STONE',
          comingSoon: false,
          disabled: false,
          id: 856,
          gameIdFF: '838',
          route: 'dragonstone',
          bullets: gameInfos['dragonstone']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/MissionA.png',
          title: 'Mission Amazon',
          id: 862,
          comingSoon: false,
          disabled: false,
          gameIdFF: '859',
          route: 'mission-amazon',
          bullets: gameInfos['mission-amazon']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/FastMines.webp',
          title: 'FastMines',
          comingSoon: false,
          disabled: true,
          id: 8,
          bullets: gameInfos['fastmines']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/Max21.png',
          title: 'Max 21',
          comingSoon: false,
          disabled: true,
          id: 9,
          bullets: gameInfos['max-21']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/Olympus.png',
          title: 'Olympus Plinko',
          comingSoon: false,
          disabled: false,
          id: 11,
          bullets: gameInfos['plinko']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/ReturnRA.png',
          title: 'Return of RA',
          comingSoon: true,
          disabled: false,
          id: 829,
          bullets: gameInfos['return-of-ra']?.fastplay || [],
        },
      ],
      lobbyGamesFP: [
        {
          imageURL: '/images/cards/fastplay/Max21.png',
          title: 'Max 21',
          comingSoon: false,
          disabled: true,
          id: 9,
          launchConfig: [9, 'FF', 'extended', 9],
          bullets: gameInfos['max-21']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/MaxDice.png',
          title: 'Max Dice',
          comingSoon: false,
          disabled: true,
          id: 7,
          launchConfig: [7, 'FF', 'extended', 7],
          bullets: gameInfos['max-dice']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/FastMines.webp',
          title: 'FastMines',
          comingSoon: false,
          disabled: true,
          id: 8,
          launchConfig: [8, 'FF', 'extended', 8],
          bullets: gameInfos['fastmines']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/Olympus.png',
          title: 'Olympus Plinko',
          comingSoon: false,
          disabled: false,
          id: 11,
          launchConfig: [11, 'PL', 'extended', 11],
          bullets: gameInfos['plinko']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/TripleMB.png',
          title: 'Triple Max Blast',
          gameIdFF: '875',
          comingSoon: false,
          disabled: false,
          id: 875,
          redirect: 'maxblast',
          bullets: gameInfos['maxblast']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/SectorX.png',
          alias: 'SECTOR_X',
          title: 'Sector X',
          comingSoon: false,
          disabled: false,
          id: 867,
          gameIdFF: '866',
          route: 'sector-x',
          bullets: gameInfos['sector-x']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/Dragonstone.png',
          title: 'DragonStone',
          alias: 'DRAGON_STONE',
          comingSoon: false,
          disabled: false,
          id: 856,
          gameIdFF: '838',
          route: 'dragonstone',
          bullets: gameInfos['dragonstone']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/MissionA.png',
          title: 'Mission Amazon',
          id: 862,
          comingSoon: false,
          disabled: false,
          gameIdFF: '859',
          route: 'mission-amazon',
          bullets: gameInfos['mission-amazon']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/fastplay/ReturnRA.png',
          title: 'Return of RA',
          id: 829,
          comingSoon: true,
          disabled: false,
          gameIdFF: 829,
          bullets: gameInfos['return-of-ra']?.fastplay || [],
        },
      ],
      lobbyGamesPVP: [
        {
          imageURL: '/images/cards/new/MM.webp?v=1',
          title: 'MultiMines',
          alias: 'MULTIMINES',
          comingSoon: true,
          disabled: true,
          id: 6,
          redirect: 'playervsplayer/multimines',
          bullets: gameInfos['multi-mines']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/R21.webp?v=1',
          title: 'Rolling 21',
          alias: 'ROLLING_21',
          comingSoon: true,
          disabled: true,
          id: 5,
          redirect: 'playervsplayer/rolling-21',
          bullets: gameInfos['rolling-21']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/ROH.webp?v=1',
          alias: 'ROLL_OR_HOLD',
          title: 'Roll Or Hold',
          comingSoon: true,
          disabled: true,
          id: 2,
          redirect: 'playervsplayer/roll-or-hold',
          bullets: gameInfos['roll-or-hold']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/MP.webp?v=1',
          title: 'Multiplinko',
          alias: 'MULTIPLINKO',
          comingSoon: false,
          disabled: false,
          id: 1,
          redirect: '/lobby/plinko',
          bullets: gameInfos['plinko']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/MBC.webp?v=1',
          title: 'MaxBlast Champs',
          alias: 'MAX_BLAST_CHAMPS',
          comingSoon: false,
          disabled: false,
          id: 864,
          redirect: '/maxblastchamps',
          bullets: gameInfos['maxblast']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/SX.webp?v=1',
          alias: 'SECTOR_X',
          title: 'Sector X',
          comingSoon: false,
          disabled: false,
          id: 867,
          route: 'sector-x',
          bullets: gameInfos['sector-x']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/DS.webp?v=1',
          title: 'DragonStone',
          alias: 'DRAGON_STONE',
          comingSoon: false,
          disabled: false,
          id: 856,
          route: 'dragonstone',
          bullets: gameInfos['dragonstone']?.pvp || [],
        },
        {
          imageURL: '/images/cards/new/MA.webp?v=1',
          title: 'Mission Amazon',
          id: 862,
          comingSoon: false,
          disabled: false,
          route: 'mission-amazon',
          bullets: gameInfos['mission-amazon']?.pvp || [],
        },
      ],
      plinkoGames: [
        {
          imageURL: '/images/cards/fastplay/Olympus.png',
          title: 'Olympus Plinko',
          comingSoon: false,
          disabled: false,
          id: 11,
          launchConfig: [11, 'PL', 'extended', 11],
          bullets: gameInfos['plinko']?.fastplay || [],
        },
        {
          imageURL: '/images/cards/new/MP.webp?v=1',
          title: 'Multiplinko',
          alias: 'MULTIPLINKO',
          redirect: '/lobby/plinko',
          id: 1,
          comingSoon: false,
          disabled: false,
          bullets: gameInfos['plinko']?.pvp || [],
        },
      ],
    }),

    computed: {
      sidebarIsOpened() {
        return !this.$store.state.sidebar;
      },

      userSignedIn() {
        return !!this.$store.getters.getuser;
      },

      gameCards() {
        let result = [];

        switch (this.$route.name) {
          case 'challengefriends':
            result = this.games;
            break;

          case 'fastplay':
            result = this.fpGames;
            break;

          case 'lobby':
            result = this.type === 'fastplay' ? this.lobbyGamesFP : this.lobbyGamesPVP;
            break;

          case 'plinko':
            result = this.plinkoGames;
            break;

          default:
            result = this.newGamesList;
            break;
        }

        if (!this.userSignedIn) {
          return result.filter((game) => !game.disabled);
        }

        return result
          .filter((game) => this.isGameAvailable(game.id))
          .map((game) => ({ ...game, comingSoon: this.isGameComingSoon(game.id) }))
          .sort((a, b) => a.comingSoon - b.comingSoon);
      },
    },

    methods: {
      isGameAvailable(gameId) {
        if (this.$store.getters.getActiveGames.length) {
          return this.$store.getters.getActiveGames.find((game) => game.key === String(gameId)).active;
        }
        return false;
      },
      isGameComingSoon(gameId) {
        if (this.$store.getters.getActiveGames.length) {
          return this.$store.getters.getActiveGames.find((game) => game.key === String(gameId))?.comingSoon;
        }
        return false;
      },
      setClickedCard(index, flag) {
        if (flag) return;
        this.clickedCard = this.clickedCard === index ? null : index;
      },
      performAction(game) {
        switch (this.$route.name) {
          case 'challengefriends':
            this.selectGame(game);
            break;
          case 'playervsplayer':
            if (this.userSignedIn) {
              if (game.comingSoon) {
                this.$store.dispatch('showAlertDialog', {
                  title: 'Coming Soon',
                  text: 'This game is coming soon! Stay tuned for further updates.',
                });
                break;
              }
              this.goToGameBuyInPage(game);
              break;
            }
            this.openSignUpDialog();
            break;
          case 'dashboard':
            if (this.userSignedIn) {
              if (game.comingSoon) {
                this.$store.dispatch('showAlertDialog', {
                  title: 'Coming Soon',
                  text: 'This game is coming soon! Stay tuned for further updates.',
                });
                break;
              }
              this.goToGameBuyInPage(game);
              break;
            }
            this.openSignUpDialog();
            break;
          default:
            if (this.userSignedIn) {
              if (game.comingSoon) {
                this.$store.dispatch('showAlertDialog', {
                  title: 'Coming Soon',
                  text: 'This game is coming soon! Stay tuned for further updates.',
                });
                break;
              }

              if (game.launchConfig) {
                this.launchGame(...game.launchConfig);
                break;
              } else if (game.gameIdFF) {
                this.launchGame(game.gameIdFF, 'FF');
                break;
              }
              if (game.route) {
                this.$router.push(`/playervsplayer/${game.route}`);
              } else {
                this.$router.push(game.redirect);
                break;
              }
            } else {
              this.openSignUpDialog();
            }
            break;
        }
      },
      selectGame(game) {
        if (!game.id) {
          return;
        }

        if (game.id === 864 && !this.$route.name.includes('challenge')) {
          // temporal check for MBC to work only in CAF
          return;
        }

        this.selectedGame = game.id;
        this.$emit('selectGame', game.id);
      },
      goToGameBuyInPage(game) {
        if (game.route) {
          this.$router.push(`/playervsplayer/${game.route}`);
        } else if (game.redirect) {
          this.$router.push(game.redirect);
        }
      },
      openSignUpDialog() {
        this.$store.dispatch('changeSignupDialogState', true);
      },
    },
  };
</script>

<template>
  <div class="w-full my-5">
    <v-row :class="{ 'game-cards-container--with-sidebar': sidebarIsOpened }" class="game-cards-container">
      <v-col
        v-for="(game, index) of gameCards"
        :key="index"
        v-is-available="game.alias"
        class="game-card-column"
        cols="6"
      >
        <div class="position-relative">
          <img
            v-if="game.comingSoon"
            v-reload-on-fail
            alt="coming-soon"
            class="card-coming-soon no-pointer-events"
            src="/images/icons/coming-soon-sm.png?v=1"
          />
          <v-img
            :aspect-ratio="6 / 5"
            :class="{
              'coming-soon-grayed': game.comingSoon,
              'is-clicked': clickedCard === index,
            }"
            :src="game.imageURL"
            class="game-card-image"
            height="100%"
            @click="setClickedCard(index, game.comingSoon)"
          >
            <cta-button v-if="!game.comingSoon" @click.stop="performAction(game)">PLAY NOW</cta-button>

            <div :class="{ 'd-block': clickedCard === index }" class="game-card-articles fade d-none">
              <div class="game-title d-flex justify-space-between text-h5 text-md-h4 font-weight-600">
                {{ game.title }}
                <v-btn class="close-button-white" icon style="z-index: 3">
                  <v-icon color="white">mdi-close</v-icon>
                </v-btn>
              </div>
              <div v-for="(bullet, index) of game.bullets" :key="index" class="info-bullet">
                <div class="bullet-wrapper">
                  <component :is="`${bullet.svgIcon}Icon`" class="bullet-icon" />
                  <div class="bullet-text" v-html="bullet.text" />
                </div>
              </div>
            </div>
          </v-img>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
  .coming-soon-grayed::v-deep {
    filter: blur(5px) !important;
    overflow: hidden;

    .v-responsive__sizer {
      background-color: rgba(136, 121, 184, 0.4);
    }
  }

  .card-coming-soon {
    position: absolute;
    max-width: 70%;
    right: 50%;
    top: 50%;
    transform: translate(50%, -50%);
    z-index: 4;
  }

  .game-card-articles {
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: start;
    flex-direction: column;
    color: white;
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: #191919;
    border-radius: 16px;

    @media screen and (min-width: 993px) {
      padding: 18px;
    }

    .v-btn {
      align-self: center;
      justify-self: flex-end;
    }

    .desc-bullet:nth-child(2) {
      @media (max-width: 600px) {
        margin-top: 0 !important;
      }
    }

    .bullet-icon {
      width: 10px;
      height: 10px;

      @media screen and (min-width: 993px) {
        width: 18px;
        height: 18px;
      }
    }

    .info-bullet {
      margin-top: 8px;

      @media screen and (min-width: 420px) {
        margin-top: 12px;
      }

      &::v-deep {
        .bullet-wrapper {
          display: grid;
          grid-template-columns: 10px 1fr;
          grid-gap: 4px;
          align-items: baseline;

          @media screen and (min-width: 990px) {
            grid-template-columns: 20px 1fr;
          }
        }

        .bullet-text {
          strong {
            color: #f8bf1e;
          }

          @media screen and (min-width: 420px) {
            font-size: 16px;
            line-height: 18px;

            strong {
              display: block;
              font-size: 20px;
            }
          }

          @media screen and (min-width: 990px) {
            font-size: 20px;
            line-height: 22px;

            strong {
              font-size: 24px;
            }
          }
        }
      }
    }
  }

  .game-card-image::v-deep {
    position: relative;
    border-radius: 16px;
    cursor: pointer;

    .v-responsive__content {
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }

    &:hover:not(.coming-soon-grayed) {
      transition: all 0.3s ease;
      box-shadow: 0 0 0 2px var(--v-gold-base);
    }

    &.is-clicked {
      &:hover {
        box-shadow: 0 0 0 2px white !important;
      }
    }
  }

  .game-cards-container::v-deep {
    text-align: left !important;
    max-width: 1000px;
    margin: 0 auto !important;
    padding: 0 20px;

    .game-card-button {
      margin-bottom: 28px !important;
      min-width: 70% !important;
      min-height: 42px !important;

      @media screen and (min-width: 993px) {
        margin-bottom: 38px !important;
      }

      span {
        font-weight: 650 !important;
        font-size: 28px !important;
      }
    }

    @media screen and (max-width: 993px) {
      padding: 0;

      .game-card-button {
        min-height: 30px !important;

        span {
          font-size: 20px !important;
        }
      }
    }

    @media screen and (max-width: 750px) {
      .game-card-column {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    @media screen and (max-width: 750px) {
      max-width: 400px;
    }
  }

  .game-cards-container--with-sidebar {
    @media screen and (min-width: 993px) and (max-width: 1310px) {
      .is-clicked {
        .game-card-button {
          display: none !important;
        }

        .info-bullet {
          margin-top: 8px;
        }
      }
    }
  }

  .cta-button {
    position: absolute;
    z-index: 1;
    bottom: 20px;
    width: 55%;
    aspect-ratio: 136 / 21;
    height: initial;
    min-width: auto;
    max-width: 272px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: clamp(16px, 1.05vw, 22px);

    @media screen and (max-width: 600px) {
      font-size: clamp(14px, 1.05vw, 22px);
      padding-bottom: 1px;
    }

    @media screen and (min-width: 1280px) {
      font-size: clamp(16px, 1.4vw, 20px);
    }
  }
</style>
